// use version specified in Info.plist
// as `DeviceInfo.getVersion()` returns 'unknown' for web build

const plist = require('plist')
const infoPlist = require('../../ios/nutrisense/Info.plist')

export default plist.parse(infoPlist).CFBundleShortVersionString
